import { __ } from '../../../locales'

const ReviewItemFrameFilter = ({ inputs, onInputsChange }) => {
    const rand = Math.random()

    return (
        <div className={'input-component row'}>
            <input
                id={'frame-filter' + rand}
                type="checkbox"
                className="form-control"
                checked={inputs.itemFrame}
                onInput={(ev) => onInputsChange('itemFrame', ev.target.checked)}
            />
            <label for={'frame-filter' + rand}>{__('inputs.review_border.label')}:</label>
        </div>
    );
};

export default ReviewItemFrameFilter;
